import { effect, Injectable, signal } from '@angular/core';
import { cm, DayTripsGuide, Guides, GuideType } from '@sp-shared';
import { RouteNames, Routes } from '../enums/routes.enum';
import { DirectoryTile } from '../interfaces/directory-tile.interface';
import { ConfigService } from './config.service';
import { FavoritesService } from './favorites.service';
import { GuidesService } from './guides.service';

import { LogService } from './log.service';
@Injectable({
	providedIn: 'root'
})
export class DayTripsService {
	guidesId = '';
	dayTripsSignal = signal<DayTripsGuide[] | null>(null);
	dayTrips: DayTripsGuide[];
	favorites: string[] = [];
	dashboardTiles = signal<DirectoryTile[] | null>(null);
	favoritesTiles = signal<DirectoryTile[] | null>(null);

	constructor(
		private guidesService: GuidesService,
		private favoritesService: FavoritesService,
		private configService: ConfigService,
		private log: LogService
	) {
		effect(() => {
			const guides = this.guidesService.guidesSignal();
			if (cm.isNotEmpty(guides)) {
				this.handleGuidesUpdate(guides);
			}

			this.favorites = this.favoritesService.favoritesSignal();
			if (cm.isNotEmpty(this.dayTrips)) {
				// 	//this.setFavorites(faveIds);
				this.createDashboardTiles(this.favorites);
				this.createFavoriteTiles(this.favorites);
			}
		});
	}

	async handleGuidesUpdate(guides: Guides): Promise<void> {
		this.guidesId = guides.id;
		if (guides.dayTripGuides?.length > 0) {
			this.dayTrips = guides.dayTripGuides;
			this.dayTripsSignal.set(this.dayTrips);
		}
	}

	async createDashboardTiles(favorites: string[] = []): Promise<void> {
		let dashboardTiles: DirectoryTile[] = [];
		for (const dayTrip of this.dayTripsSignal()) {
			dashboardTiles.push({
				id: dayTrip.id,
				title: dayTrip?.cityName,
				type: GuideType.Trip,
				label: 'Day Trips Near',
				url: this.configService.setupLink(RouteNames.DayTrips, [dayTrip?.cityName?.toLowerCase()]),
				bookmarked: favorites?.includes(dayTrip.id) ?? false,
				color: 'rosewood'
			} as DirectoryTile);
		}
		this.dashboardTiles.set(dashboardTiles);
	}

	async createFavoriteTiles(favorites: string[] = []): Promise<void> {
		const dayTrips = this.dayTripsSignal().filter(trip => favorites.includes(trip.id));

		let tiles: DirectoryTile[] = [];
		for (const dayTrip of dayTrips) {
			tiles.push({
				id: dayTrip.id,
				title: `Day Trips Near ${dayTrip.cityName}`,
				label: '',
				url: this.configService.setupLink(RouteNames.DayTrips, [dayTrip?.cityName?.toLowerCase()]),
				bookmarked: true,
				color: 'rosewood'
			} as DirectoryTile);
		}
		this.favoritesTiles.set(tiles);
	}

	setTripFavorite(id: string) {
		// this.log.debug('Day trip favorited', id);
		// this.dayTrips = this.dayTrips = this.dayTrips.map(item => ({ ...item, isFavorited: item.id === id }));
		// this.planService.setDayTripFavorite(id);
		// this.dayTripsSignal.set({ ...this.dayTrips });
		// this.log.debug('Day trip favorited', this.dayTripsSignal());
	}

	setFavorites(faveIds: string) {
		// this.log.debug('set favorites');
		const tripFaveIds = new Set(faveIds);
		if (cm.isEmpty(this.dayTripsSignal())) return;
		const dayTrips = this.dayTripsSignal();
		// this.dayTripsSignal.set(tripsToFave);
	}
}
